export const getCookieValue = (cookieName: string): string | undefined => {
    if (typeof document === 'undefined') return undefined;

    const cookiesString = document.cookie ?? '';
    if (!cookiesString) return undefined;

    const cookies = cookiesString.split(';');
    for (const rawCookie of cookies) {
        const trimmed = rawCookie.trim();
        if (!trimmed) continue;

        const eqIndex = trimmed.indexOf('=');
        const key = eqIndex === -1 ? trimmed : trimmed.slice(0, eqIndex);
        if (key === cookieName) {
            return eqIndex === -1 ? '' : trimmed.slice(eqIndex + 1);
        }
    }
    return undefined;
};
